// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-228d92e4] img{-o-object-fit:contain;object-fit:contain}[data-v-228d92e4] .img-border{border:1px solid #9b9b9b}[data-v-228d92e4] .hr-lg{border-top:2px solid #dcdcdc}[data-v-228d92e4] .h5,[data-v-228d92e4] h5{font-size:.9rem}[data-v-228d92e4] .product .product-name,[data-v-228d92e4] .product h3{color:#4a4a4a}[data-v-228d92e4] .product .product-image{width:90px;height:90px}@media(max-width:350px){[data-v-228d92e4] .product .product-image{width:60px;height:60px}}", ""]);
// Exports
module.exports = exports;
